import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import AgriApplication from '@/models/AgriApplication.js'

export const useAgriApplicationStore = defineStore('agriApplicationStore', () => {
  let syncableModel = useSyncableModel(useApiResource('agri_applications'), {
    className: AgriApplication.modelName.name,
    paramKey: AgriApplication.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
